import pic1 from '../utils/workImg/milan.jpg'
import pic2 from '../utils/workImg/samdaria.jpg'
import pic3 from '../utils/workImg/uwp.jpg'
import pic4 from '../utils/workImg/alphawalk.png'





export const workData = [
  {
    id: 1,
    title: "Samdaria and Associates",
    content: "/Portfolio for a Law Firm",
    image: pic2,
   
    link:"https://www.samdarriaandassociates.com/",
   
  },
  // {
  //   id: 2,
  //   title: "Alphawalk",
  //   content: "/Website for the company Alphawalk ",
  //   image: pic4,
   
  //   link:"https://www.alphawalk.in/",
   
  // },
    // {
    //   id: 3,
    //   title: "MILAN Site",
    //   content: "/Created College cultural fest website with Team.",
    //   image: pic1,
     
    //   link:"https://srmmilan.org/",
     
    // },
    {
      id: 2,
      title: "UWP",
      content: "/Created Online portal to upload faculties research Paper with Team.",
      image: pic3,
     
      link:"https://uwp.srmist.edu.in/",
     
    },
  
  
 
   
    ]